import { useAuthState } from 'contexts/AuthProvider';
import { useAddAttendanceCheckNotiMutation } from 'queries/activityPoint/useAddAttendanceCheckNotiMutation';
import { useDeleteAttendanceCheckNotiMutation } from 'queries/activityPoint/useDeleteAttendanceCheckMutation';
import { useGetAttendanceCheckNotiQuery } from 'queries/activityPoint/useGetAttendanceCheckNotiQuery';
import { useCallback, useEffect, useState } from 'react';
import { NotiButton } from 'ui-components/navigations/HeaderButtons';
import { useRequestSign } from 'ui-hooks/useRequestSign';
import { showAlertModal, showToast } from 'utils/modal';

export const AttendanceCheckNotiButton = () => {
  const { isLoggedIn } = useAuthState();
  const requestSign = useRequestSign();

  const { data } = useGetAttendanceCheckNotiQuery();

  const [isEnabled, setIsEnabled] = useState(!!data?.isEnabled);

  const { mutate: addMutate } = useAddAttendanceCheckNotiMutation({
    onMutate: () => {
      showToast('출석체크 알림이 설정되었어요.');
      setIsEnabled(true);
    },
    onError: () => {
      setIsEnabled(false);
      showToast('알림 설정에 실패했어요.');
    },
  });
  const { mutate: deleteMutate } = useDeleteAttendanceCheckNotiMutation({
    onMutate: () => setIsEnabled(false),
    onError: () => {
      setIsEnabled(true);
      showToast('알림 해제에 실패했어요.');
    },
  });

  const handleClick = useCallback(() => {
    if (!isLoggedIn) {
      requestSign();
      return;
    }

    if (isEnabled) {
      deleteMutate();
      showToast('출석체크 알림이 해제되었어요.');
    } else {
      showAlertModal(
        {
          title: '출석체크 알림을 설정하시겠어요?',
          description: '매일 18시에 출석체크할 수 있게 푸시 알림을 보내 드릴게요.',
        },
        { cancelText: '취소', confirmText: '출석체크 알림 설정', onConfirm: addMutate },
      );
    }
  }, [addMutate, deleteMutate, isEnabled, isLoggedIn, requestSign]);

  useEffect(() => {
    setIsEnabled(!!data?.isEnabled);
  }, [data?.isEnabled]);

  return <NotiButton fill={isEnabled} onClick={handleClick} />;
};
